import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M283 208.6V34.4H110.8v39.2H220L63 228l26.2 27.6L246 101.1v107.5z"
})), 'TrendUpIcon');